import { NullState } from '@mi-front/ui';
import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { useVideoStations } from '../../core/stations/hooks/useVideoStations';

export function IfAnyVideoStation({ children }: PropsWithChildren<unknown>) {
  const videoStations = useVideoStations();

  if (!videoStations.length) {
    return (
      <Box mt={4}>
        <NullState className="text-left">
          <FormattedMessage
            id="stations.noVideoStations"
            defaultMessage="No hay emisoras de video registradas"
          />
        </NullState>
      </Box>
    );
  }

  return <>{children}</>;
}
